import { EXPERIENCE_PROGRAMS } from "@/data/experiencePrograms";

export const ABOUT_PAGES = [
  { to: "/ki-vagyok-en", label: "Ki vagyok én?" },
  { to: "/misszio", label: "Misszió" },
  { to: "/egy-erzes", label: "Egy érzés" },
  { to: "/milyen-terbe-erkezel", label: "Milyen térbe érkezel?" },
];

export const FORRAS_KOD_PAGES = [
  { to: "/forras-kod-kiseres", label: "Forrás-Kód® Kísérés" },
  { to: "/szolgaltatasok", label: "Szolgáltatások" },
  { to: "/konzultacio", label: "Konzultáció" },
];

export const EXPERIENCE_PAGES = [
  { to: "/elmenyprogramok", label: "Összes élményprogram" },
  ...EXPERIENCE_PROGRAMS.map((p) => ({ to: p.to, label: p.menuLabel })),
];

export const NAV_ITEMS = [
  { to: "/", label: "Főoldal" },
  { to: "/ki-vagyok-en", label: "Rólam", children: ABOUT_PAGES },
  { to: "/forras-kod-kiseres", label: "Forrás-Kód", featured: true, children: FORRAS_KOD_PAGES },
  { to: "/aktualis-programok", label: "Aktuális programok" },
  { to: "/elmenyprogramok", label: "Élményprogramok", children: EXPERIENCE_PAGES },
  { to: "/kapcsolodas-melysegei", label: "A kapcsolódás mélységei" },
  { to: "/visszajelzesek", label: "Visszajelzések" },
  { to: "/kapcsolat", label: "Kapcsolat" },
];
